import moment from 'moment';

// validation-patterns.ts

export const numberPattern = '^[0-9]+(.[0-9]+)?$';
export const alphanumericPattern = '^[a-zA-Z0-9]+$';
export const alphabeticPattern = '^[a-zA-Z]+$';
export const emailValidationPattern =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

// date-format-patterns.ts

export const dateFormat = 'YYYY-MM-DD';
export const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
